import React from 'react';
import { about } from '../../content/siteContent';
import SectionHead from './SectionHead';
import { StarIcon, StrokeIcon } from './Icons';

export default function About() {
  const { lead, text, pillars, award } = about;

  return (
    <section id="quem-somos" className="section-wrap">
      <span id="features" className="anchor-alias" aria-hidden="true" />

      <SectionHead tag={about.tag} title={about.title} subtitle={about.subtitle} />

      <div className="about-card">
        <div className="about-layout">
          <div>
            <p className="about-lead">
              {lead.before}
              <strong>{lead.strong}</strong>
              {lead.after}
            </p>
            <p className="about-text">{text}</p>

            <div className="about-pillars">
              {pillars.map((pillar) => (
                <div className="about-pillar" key={pillar.title}>
                  <div className="hex-icon hex-icon--sm">
                    <StrokeIcon name={pillar.icon} size={18} />
                  </div>
                  <div>
                    <div className="about-pillar-title">{pillar.title}</div>
                    <div className="about-pillar-desc">{pillar.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="about-badge-card">
              {/* Mesmo selo da referência; o link do Prêmio Sebrae vem do site atual. */}
              <a
                href={award.link}
                target="_blank"
                rel="noopener noreferrer"
                className="sebrae-seal"
                aria-label="Prêmio Sebrae Startups (abre em nova aba)"
              >
                <StarIcon />
              </a>
              <span className="section-tag section-tag--sm">{award.tag}</span>
              <h3 className="about-badge-title">{award.title}</h3>
              <p className="about-badge-text">{award.text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
